import * as angular from 'angular';
import { ConstantsModule } from '@buildium/angularjs-core/dist/constants';
import { GlobalizeLoaderService } from './globalize-loader.service';

export const GlobalizeLoaderModule = angular.module('buildium.manager.globalize-loader', [
    ConstantsModule.name
])
    .service('GlobalizeLoaderService', GlobalizeLoaderService);
